import { LeanToSettingConfig } from "./LeanToSettingConfig";
import { SignalConfig } from "./SignalConfig";

interface ILeanToWraparoundSettingConfig
{
	vertical: string;
	horizontal: string;
	verticalLeanTo?: LeanToSettingConfig;
	horizontalLeanTo?: LeanToSettingConfig;
}

export class LeanToWraparoundSetting
{
	public static CONFIGS:ILeanToWraparoundSettingConfig[] = [
		{
			vertical: "back",
			horizontal: "left"
		},
		{
			vertical: "back",
			horizontal: "right"
		},
		{
			vertical: "front",
			horizontal: "left"
		},
		{
			vertical: "front",
			horizontal: "right"
		}
	];

	// allowed means that it can be enabled
	public allowed : SignalConfig<boolean>;
	public notAllowedReason : SignalConfig<string>

	// enabled is true if the user enables it
	public enabled : SignalConfig<boolean>;

	public vertical : string;
	public horizontal : string;

	private _verticalLeanTo   : LeanToSettingConfig;
	private _horizontalLeanTo : LeanToSettingConfig;

	constructor(config: ILeanToWraparoundSettingConfig)
	{
		this.horizontal = config.horizontal;
		this.vertical   = config.vertical;

		// TODO maybe false is not good for initial value
		this.allowed = new SignalConfig<boolean>({value: false});
		this.enabled = new SignalConfig<boolean>({value: false});

		this.notAllowedReason = new SignalConfig<string>({value: ""});

		this._verticalLeanTo   = config.verticalLeanTo;
		this._horizontalLeanTo = config.horizontalLeanTo;

		this.addListeners();

		this.update();
	}

	private addListeners()
	{
		this.addLeanToListener(this._verticalLeanTo);
		this.addLeanToListener(this._horizontalLeanTo);
	}
	public addExternalListener = (signal: SignalConfig<number>) =>
	{
		signal.signal.add(this.update);
	}

	private addLeanToListener(leanTo:LeanToSettingConfig)
	{
		leanTo.length.signal.add(this.update);
		leanTo.pitch.signal.add(this.update);
		leanTo.drop.signal.add(this.update);
		leanTo.enabled.signal.add(this.update);
		leanTo.cut_back.signal.add(this.update);
		leanTo.cut_front.signal.add(this.update);
	}

	private update = () =>
	{
		var allowed = this.getAllowed();

		if (allowed !== this.allowed.value)
		{
			this.allowed.setValue(allowed);
		}

		// enabled can only be true if it's allowed
		if (!allowed)
		{
			if (this.enabled.value)
			{
				this.enabled.setValue(false);
			}
		}
	};

	private getAllowed()
	{
		if (!this._verticalLeanTo.enabled.value || !this._horizontalLeanTo.enabled.value)
		{
			this.notAllowedReason.setValue("Both adjacent Lean-to's need to be enabled!");
			return false;
		}

		if (this._verticalLeanTo.length.value !== this._horizontalLeanTo.length.value)
		{
			this.notAllowedReason.setValue("Both adjacent Lean-to's need to have the same Width!");
			return false;
		}
		if (this._verticalLeanTo.pitch.value !== this._horizontalLeanTo.pitch.value)
		{
			this.notAllowedReason.setValue("Both adjacent Lean-to's need to have the same Pitch!");
			return false;
		}
		if (this._verticalLeanTo.drop.value !== this._horizontalLeanTo.drop.value)
		{
			this.notAllowedReason.setValue("Both adjacent Lean-to's need to have the same Drop!");
			return false;
		}

		/*var insetBayConfig = Main.getInstance().config.building.insetBay;
		if (this.vertical === "back" && insetBayConfig.back.count.value > 0)
		{
			this.notAllowedReason.setValue("The inset bay and this wraparound cannot be present at the same time.");
			return false;
		}

		if (this.vertical === "front" && insetBayConfig.front.count.value > 0)
		{
			this.notAllowedReason.setValue("The inset bay and this wraparound cannot be present at the same time.");
			return false;
		}*/

		// check if cuts match
		//
		// L: left, R: right, B: back, F: front
		// 1: cut_front
		// 2: cut_back
		//
		//     -------
		//     2  B  1
		//     -------
		// | 2 |     | 2 |
		// |   |     |   |
		// | L |     | R |
		// |   |     |   |
		// | 1 |     | 1 |
		//     -------
		//     2  F  1
		//     -------
		//

		if (this.vertical === "back")
		{
			var horizontal_cut = this._horizontalLeanTo.cut_back.value;
		}
		else
		{
			horizontal_cut = this._horizontalLeanTo.cut_front.value;
		}
		if (this.horizontal === "left")
		{
			var vertical_cut = this._verticalLeanTo.cut_back.value;
		}
		else
		{
			vertical_cut = this._verticalLeanTo.cut_front.value;
		}

		if (horizontal_cut !== 0 || vertical_cut !== 0)
		{
			this.notAllowedReason.setValue("Both adjacent Lean-to's need to have 0 cuts!");
			return false;
		}

		// everything matches
		this.notAllowedReason.setValue("");
		return true;
	}

	public getOtherLeanTo(leanToConfig:LeanToSettingConfig):LeanToSettingConfig
	{
		if (this._verticalLeanTo === leanToConfig)
		{
			return this._horizontalLeanTo;
		}
		return this._verticalLeanTo;
	}
}
